import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  FormLabel,
} from '@chakra-ui/react'

import { CountBadgeAccordion } from '../CountBadge'

interface FormAccordionWrapperIProps {
  label: string
  children?: React.ReactNode
  numberSelected?: number | null
  onAccordionButtonClick?: (isExpanded: boolean) => void
  labelStyle?: React.CSSProperties
}

export const FormAccordionWrapper = ({
  label,
  numberSelected,
  children,
  onAccordionButtonClick,
  labelStyle,
}: FormAccordionWrapperIProps) => {
  const shouldShowNumberSelected =
    numberSelected !== 0 && numberSelected !== null
  return (
    <Accordion
      allowToggle
      border='1px solid #d9d9d9'
      borderRadius='8px'
      m='0px'
      px='16px'
      py='8px'
    >
      <AccordionItem border='none'>
        {({ isExpanded }) => (
          <>
            <AccordionButton
              _hover={{ backgroundColor: 'inherit' }}
              alignItems='center'
              display='flex'
              justifyContent='space-between'
              onClick={() => onAccordionButtonClick?.(isExpanded)}
              px='inherit'
            >
              <Flex alignItems='center'>
                <FormLabel letterSpacing='-0.8px' mb='0' style={labelStyle}>
                  {label}
                </FormLabel>
                {shouldShowNumberSelected && !isExpanded && (
                  <CountBadgeAccordion text={numberSelected} />
                )}
              </Flex>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel pb='0' px='inherit'>
              {children}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}
